import { z } from 'zod'

/**
 * Only the people are typed here. The mentoring type, the cadence and the hours
 * come from the tabs and the slider the visitor already sees, so staff builds
 * the product exactly the way a client would and then says who it is for.
 */
export const mentoringOfferFormSchemaZ = z.object({
  buyerEmail: z.union([
    z.literal(''),
    z
      .email('Podaj poprawny adres e-mail kupującego')
      .max(254, 'Adres e-mail kupującego jest zbyt długi')
  ]),
  buyerName: z
    .string()
    .trim()
    .max(200, 'Imię i nazwisko kupującego może mieć maksymalnie 200 znaków'),
  studentEmail: z
    .email('Podaj poprawny adres e-mail ucznia')
    .max(254, 'Adres e-mail ucznia jest zbyt długi'),
  studentName: z
    .string()
    .trim()
    .min(1, 'Podaj imię i nazwisko ucznia')
    .max(200, 'Imię i nazwisko ucznia może mieć maksymalnie 200 znaków')
})

export type MentoringOfferFormSchema = z.infer<typeof mentoringOfferFormSchemaZ>

export const MENTORING_OFFER_FORM_DEFAULTS: MentoringOfferFormSchema = {
  buyerEmail: '',
  buyerName: '',
  studentEmail: '',
  studentName: ''
}
